/* eslint-disable */
import React from "react";
import { AiFillTwitterCircle } from "react-icons/ai";

function Fotter() {
  return (
    <div id="fotterArea" className="fotterArea">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center">
            <h1 className="fotterTitle">Evan Mandery</h1>
            <p className="fotterSubTitle">
              Literary Agent: Stephanie Steiker, Regal Hoffman & Associates
              <br />
              <br />
              Film & Television: Dana Spector, CAA
            </p>
            <a href="https://twitter.com/EvanMandery" className="socialLink position-relative" target="_blank">
              <AiFillTwitterCircle className="twitterIcon position-absolute" />
              @EvanMandery
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Fotter;
